<div class="container mt-3">
  <fgbcl-marketplace-list-v2 [isList]="true" [marketplaceItemTypes]="[3, 5]" [eventItemView]="true" />
</div>
